import {ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UiGridModule} from '@csgofast/ui/grid';
import {MatIconModule} from '@angular/material/icon';
import {BalanceWidgetComponentModule} from '../balance-widget/balance-widget.component';
import {RouterModule} from '@angular/router';
import {ActivePanel, ICurrencyRate, ILocales, IUserDetailed, MenuLink, Panel, SubPanel, Themes} from '@dev-fast/types';
import {TranslateModule} from '@ngx-translate/core';
import {MatDividerModule} from '@angular/material/divider';
import {UserAvatarModule} from '../user-avatar';
import {BalanceWidgetConfig} from '../balance-widget';
// FIXME заменить на ngx-scrollbar (уже установлен на проекте)
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';

@Component({
  selector: 'fast-ui-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent implements OnInit {
  @Input() public links: MenuLink[];
  @Input() public balance: BalanceWidgetConfig;

  @Input() public soundState: boolean;
  @Input() public user: IUserDetailed | null;
  @Input() public canLevelUp: boolean;

  @Input() public currentTheme: Themes | undefined;
  @Input() public themeList: Themes[];

  @Input() public currentLang: ILocales | undefined;
  @Input() public langList: ILocales[];

  @Input() public currentCurrency: ICurrencyRate | undefined;
  @Input() public currencyList: ICurrencyRate[];

  @Input() public currentPanel: Panel | undefined | null;

  @Output() public closeClick: EventEmitter<void>;
  @Output() public changeTheme: EventEmitter<Themes>;
  @Output() public changeLang: EventEmitter<ILocales>;
  @Output() public changeCurrency: EventEmitter<ICurrencyRate>;
  @Output() public changePanel: EventEmitter<ActivePanel | null>;

  @Output() public login: EventEmitter<void>;
  @Output() public logout: EventEmitter<void>;

  public isMenuShowed: boolean;
  public menuItems: string[];
  public panels = Panel;

  // public selectedSetting: string;
  constructor() {
    this.links = [];
    this.isMenuShowed = false;
    this.menuItems = [];
    // this.selectedSetting = '';
    this.themeList = [];
    this.langList = [];
    this.currencyList = [];
    this.closeClick = new EventEmitter(false);
    this.changeTheme = new EventEmitter(false);
    this.changeLang = new EventEmitter(false);
    this.changeCurrency = new EventEmitter(false);
    this.login = new EventEmitter(false);
    this.logout = new EventEmitter(false);
    this.changePanel = new EventEmitter(false);
    this.soundState = false;
    this.canLevelUp = false;
    this.user = null;
    this.balance = {
      countCoins: 0,
      countSkins: 0,
    };
  }
  ngOnInit(): void {
    //FIXME брать available из стейта
    this.menuItems = ['Язык', 'Цветовая схема', 'Нотификации', 'Чат'];
  }

  public toggleMenu = () => {
    this.isMenuShowed = !this.isMenuShowed;
  };
  public onCloseMenu = () => {
    this.isMenuShowed = false;
    this.selectSetting();
  };

  public selectLocale = (locale: ILocales): void => {
    this.changeLang.next(locale);
  };

  public selectCurrency = (currency: ICurrencyRate): void => {
    this.changeCurrency.next(currency);
  };

  public selectTheme = (theme: Themes): void => {
    this.changeTheme.next(theme);
  };
  public onLogin = () => {
    this.login.emit();
    this.toggleMenu();
  };

  public onLogout = () => {
    this.logout.emit();
    this.toggleMenu();
  };
  public selectSetting = (setting?: Panel | null): void => {
    if (!setting || this.currentPanel === setting) {
      // this.selectedSetting = '';
      this.changePanel.emit(null);
    } else {
      // this.selectedSetting = setting;
      this.changePanel.emit({ panel: setting, subPanel: SubPanel.NONE });
    }
  };
}

@NgModule({
  imports: [
    CommonModule,
    UiGridModule,
    MatIconModule,
    BalanceWidgetComponentModule,
    RouterModule,
    TranslateModule,
    MatDividerModule,
    UserAvatarModule,
    PerfectScrollbarModule,
  ],
  declarations: [MobileMenuComponent],
  exports: [MobileMenuComponent],
})
export class MobileMenuComponentModule {}
